export const shot_types = [
  { name: "Extreme Wide Shot" },
  { name: "Wide Shot" },
  { name: "Full Shot" },
  { name: "Medium Wide Shot" },
  { name: "Medium Shot" },
  { name: "Medium Close-Up" },
  { name: "Close-Up" },
  { name: "Extreme Close-Up" },
  { name: "Insert Shot" },
  { name: "Cutaway Shot" },
  { name: "Reaction Shot" },
  { name: "Point of View Shot" },
  { name: "Over-the-Shoulder Shot" },
  { name: "Two-Shot" },
  { name: "Three-Shot" },
  { name: "Group Shot" },
];

export const shot_frame = [
  { name: "Single Frame" },
  { name: "Two-Shot Frame" },
  { name: "Group Frame" },
  { name: "Over-the-Shoulder Frame" },
  { name: "Dirty Single" },
  { name: "Clean Single" },
  { name: "Profile Frame" },
  { name: "Symmetrical Frame" },
  { name: "Asymmetrical Frame" },
  { name: "Negative Space Frame" },
  { name: "Foreground Frame" },
  { name: "Background Reveal Frame" },
  { name: "Silhouette Frame" },
  { name: "Mirror Reflection Frame" },
  { name: "Doorway Frame" },
  { name: "Window Frame" },
  { name: "POV Frame" },
  { name: "Insert Frame" },
  { name: "Reaction Frame" },
];

export const camera_angles = [
  { name: "Eye Level" },
  { name: "Low Angle" },
  { name: "High Angle" },
  { name: "Bird’s Eye View (Top Shot)" },
  { name: "Worm’s Eye View (Ground Level)" },
  { name: "Dutch Tilt (Canted Angle)" },
  { name: "Overhead Shot" },
  { name: "Underhead Shot" },
  { name: "Shoulder Level" },
  { name: "Hip Level" },
  { name: "Knee Level" },
  { name: "Ground Level Tracking Angle" },
  { name: "Aerial Angle (Drone)" },
  { name: "Subjective Angle (POV Angle)" },
];

export const camera_movements = [
  { name: "Static (Locked-Off)" },
  { name: "Pan Left" },
  { name: "Pan Right" },
  { name: "Tilt Up" },
  { name: "Tilt Down" },
  { name: "Roll (Dutch Roll)" },
  { name: "Dolly In" },
  { name: "Dolly Out" },
  { name: "Dolly Left" },
  { name: "Dolly Right" },
  { name: "Truck Left" },
  { name: "Truck Right" },
  { name: "Pedestal Up" },
  { name: "Pedestal Down" },
  { name: "Tracking Shot" },
  { name: "Push-In" },
  { name: "Pull-Out" },
  { name: "Crane Up" },
  { name: "Crane Down" },
  { name: "Jib Shot" },
  { name: "Steadicam" },
  { name: "Handheld" },
  { name: "Whip Pan" },
  { name: "Arc Shot" },
  { name: "360 Degree Shot" },
  { name: "Orbit Shot" },
  { name: "Zoom In" },
  { name: "Zoom Out" },
  { name: "Dolly Zoom (Vertigo Effect)" },
];

export const camera_supports = [
  { name: "Tripod" },
  { name: "Monopod" },
  { name: "Static Mount (Fixed Rig)" },
  { name: "Handheld" },
  { name: "Shoulder Rig" },
  { name: "Steadicam" },
  { name: "Gimbal" },
  { name: "Dolly (On Track)" },
  { name: "Dolly (Free / Floor)" },
  { name: "Slider" },
  { name: "Crane / Jib" },
  { name: "Drone" },
  { name: "Car Mount (Rig)" },
  { name: "Body Mount" },
  { name: "Cable Cam / Wire Cam" },
];

export const lens_options = [
  { name: "14mm", type: "Ultra Wide" },
  { name: "18mm", type: "Ultra Wide" },
  { name: "24mm", type: "Wide" },
  { name: "28mm", type: "Wide" },
  { name: "35mm", type: "Wide / Standard" },
  { name: "50mm", type: "Standard" },
  { name: "65mm", type: "Standard / Portrait" },
  { name: "85mm", type: "Telephoto (Portrait)" },
  { name: "100mm", type: "Telephoto" },
  { name: "135mm", type: "Telephoto" },
  { name: "200mm", type: "Long Telephoto" },
];

export const aperture_options = [
  { value: 1.3, label: "T1.3" },
  { value: 1.4, label: "T1.4" },
  { value: 1.5, label: "T1.5" },
  { value: 1.8, label: "T1.8" },
  { value: 2.0, label: "T2.0" },
  { value: 2.2, label: "T2.2" },
  { value: 2.8, label: "T2.8" },
  { value: 3.1, label: "T3.1" },
  { value: 4.0, label: "T4.0" },
  { value: 4.5, label: "T4.5" },
  { value: 5.6, label: "T5.6" },
  { value: 6.3, label: "T6.3" },
  { value: 8.0, label: "T8" },
  { value: 9.5, label: "T9.5" },
  { value: 11, label: "T11" },
  { value: 13, label: "T13" },
  { value: 16, label: "T16" },
  { value: 22, label: "T22" },
];

export const vfx_types = [
  { name: "None" },
  { name: "Green Screen (Chroma Key)" },
  { name: "Blue Screen" },
  { name: "Set Extension" },
  { name: "Matte Painting" },
  { name: "Full CGI Environment" },
  { name: "CGI Character" },
  { name: "CGI Props" },
  { name: "Fire Simulation" },
  { name: "Smoke / Fog Simulation" },
  { name: "Water Simulation" },
  { name: "Destruction Simulation" },
  { name: "Digital Makeup / De-aging" },
  { name: "Wire Removal" },
  { name: "Object Removal" },
  { name: "Crowd Duplication" },
  { name: "Sky Replacement" },
  { name: "Weather Enhancement" },
  { name: "CG Lighting / Light Wrap" },
];

export const fps_options = [
  { value: 23.98, label: "23.98 fps" },
  { value: 24, label: "24 fps" },
  { value: 25, label: "25 fps" },
  { value: 29.97, label: "29.97 fps" },
  { value: 30, label: "30 fps" },
  { value: 48, label: "48 fps" },
  { value: 50, label: "50 fps" },
  { value: 59.94, label: "59.94 fps" },
  { value: 60, label: "60 fps" },
  { value: 120, label: "120 fps (Slow Motion)" },
  { value: 240, label: "240 fps (High Speed)" },
];

export const scene_types = [
  { name: "Happy" },
  { name: "Comic" },
  { name: "Romantic" },
  { name: "Emotional" },
  { name: "Sad" },
  { name: "Tense" },
  { name: "Suspenseful" },
  { name: "Scary" },
  { name: "Dark" },
  { name: "Mysterious" },
  { name: "Dramatic" },
  { name: "Angry" },
  { name: "Peaceful" },
  { name: "Lonely" },
  { name: "Intimate" },
  { name: "Chaotic" },
  { name: "Energetic" },
  { name: "Melancholic" },
  { name: "Inspirational" },
  { name: "Threatening" },
];

export const lighting_options = [
  { name: "High-Key" },
  { name: "Low-Key" },
  { name: "Natural Light" },
  { name: "Practical Light" },
  { name: "Hard Light" },
  { name: "Soft Light" },
  { name: "Backlight" },
  { name: "Rim Light" },
  { name: "Silhouette" },
  { name: "Motivated Lighting" },
  { name: "Neon / Colored" },
  { name: "Candlelight" },
];
export const sound_options = [
  { name: "Dialogue" },
  { name: "Voiceover" },
  { name: "Ambient" },
  { name: "Foley" },
  { name: "SFX" },
  { name: "Music Score" },
  { name: "Source Music" },
  { name: "Silence" },
  { name: "Muffled" },
  { name: "Crowd Noise" },
  { name: "Nature Atmosphere" },
  { name: "ADR" },
];

export const depth_of_field_options = [
  { name: "Shallow Focus" },
  { name: "Very Shallow Focus" },
  { name: "Deep Focus" },
  { name: "Selective Focus" },
  { name: "Rack Focus" },
  { name: "Foreground Focus" },
  { name: "Midground Focus" },
  { name: "Background Focus" },
  { name: "Split Diopter Focus" },
  { name: "Soft Diffused Focus" },
  { name: "Infinite Focus" },
  { name: "Variable Focus Pull" },
  { name: "Other" },
];

export const editing_purpose = [
  { name: "Establish Geography" },
  { name: "Introduce Character" },
  { name: "Support Dialogue" },
  { name: "Show Emotion" },
  { name: "Show Reaction" },
  { name: "Show Relationship" },
  { name: "Show Power Shift" },
  { name: "Reveal Object" },
  { name: "Reveal Information" },
  { name: "Withhold Information" },
  { name: "Build Tension" },
  { name: "Create Suspense" },
  { name: "Create Comedy Timing" },
  { name: "Show Detail" },
  { name: "Show Cause and Effect" },
  { name: "Maintain Continuity" },
  { name: "Match Action" },
  { name: "Match Eyeline" },
  { name: "Hide Cut" },
  { name: "Create Transition" },
  { name: "Show Time Passage" },
  { name: "Show Location Change" },
  { name: "Increase Pacing" },
  { name: "Slow Down Pacing" },
  { name: "Create Emotional Hold" },
  { name: "Show Decision Moment" },
  { name: "Show Realization" },
  { name: "Show Conflict" },
  { name: "Show Vulnerability" },
  { name: "Show Isolation" },
  { name: "Show Intimacy" },
  { name: "Show Threat" },
  { name: "Show Clue" },
  { name: "Create Surprise" },
  { name: "Create Shock" },
  { name: "Create Misdirection" },
  { name: "End Scene Impact" },
  { name: "Start New Beat" },
  { name: "End Beat" },
  { name: "Mark Emotional Shift" },
  { name: "Provide Editorial Safety" },
];
